// removed by extract-text-webpack-plugin
module.exports = {"form":"c-RegisterFormWizard__form","buttons":"c-RegisterFormWizard__buttons"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/RegisterFormWizard/RegisterFormWizard.scss
// module id = 1122
// module chunks = 0